const convertSecondsToDaysToDays = value => {
  return Math.ceil((value ?? 0) / 86400);
};

export default convertSecondsToDaysToDays;
